import React, { useState, useEffect } from 'react';
import { Typography, Paper, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Loader from '../../common/Loader';

const RouteNameDrilldown = (props) => {
  const [daemonConfig, setDaemonConfig] = useState([]);

  useEffect(() => {
    getRouteNameDrilldown();
  }, [props.selectedRouteName]);

  const getRouteNameDrilldown = async () => {
    let daemonConfig = await props.getRouteNameDrilldown(
      props.selectedRouteName
    );
    setDaemonConfig(daemonConfig);
  };

  const generateContent = () => {
    return (
      <>
        {generateBackButton()}
        <Typography variant="h3" gutterBottom>
          {props.selectedRouteName}
        </Typography>
        {generateTable()}
      </>
    );
  };

  const generateTable = () => {
    if (daemonConfig && Object.keys(daemonConfig).length > 0) {
      return (
        <Paper elevation={3} style={{ padding: '16px', marginTop: '16px' }}>
          <pre>{JSON.stringify(daemonConfig, null, 2)}</pre>
        </Paper>
      );
    } else {
      return <Loader />;
    }
  };

  /**
   * Generates back button to go back to the Stats page.
   * @returns button component (as a p tag)
   */
  const generateBackButton = () => {
    return (
      <Button
        variant="link"
        startIcon={<ArrowBackIcon />}
        onClick={() => props.backToMuxIdDrilldown()}>
        <Typography>Back</Typography>
      </Button>
    );
  };

  return generateContent();
};

export default RouteNameDrilldown;
